// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__23l30","choiceBoxes":"toolbarselects_choiceBoxes__vXPx9","simpleField":"toolbarselects_simpleField__3fACD"};